<div [matTooltip]="'File History'">
  <button *ngIf="isRoundBtn" class="small-icon-button" mat-icon-button (click)="openHistory()">
    <fa-icon class="fs-09 text-gray-900" [icon]="['fal', 'clock-rotate-left']"></fa-icon>
  </button>
  <button *ngIf="!isRoundBtn" mat-button (click)="openHistory()">
    <fa-icon class="fs-08" [icon]="['fal', 'clock-rotate-left']"></fa-icon>
  </button>
</div>
